export type domainProps = {
  name: string,
  url: string,
}

export type addressListProps = {
  domain: string,
  districts: domainProps[],
};

const leninskiy = {
  name: 'Ленинск',
  url: 'leninskiy',
};

const kalininskiy = {
  name: 'Калининск',
  url: 'kalininskiy',
};

const kirovskiy = {
  name: 'Кировск',
  url: 'kirovskiy',
};

const oktyabrskiy = {
  name: 'Октябрьск',
  url: 'oktyabrskiy',
};

const ordzhonikidzevskiy = {
  name: 'Орджоникидзевск',
  url: 'ordzhonikidzevskiy',
};

const sovetskiy = {
  name: 'Советск',
  url: 'sovetskiy',
};

const dzerzhinskiy = {
  name: 'Дзержинск',
  url: 'dzerzhinskiy',
};

const zavolzhskiy = {
  name: 'Заволжск',
  url: 'zavolzhskiy',
};

const frunzenskiy = {
  name: 'Фрунзенск',
  url: 'frunzenskiy',
};

const sverdlovskiy = {
  name: 'Свердловск',
  url: 'sverdlovskiy',
};

const kuybyshevskiy = {
  name: 'Куйбышевск',
  url: 'kuybyshevskiy',
};

const zheleznodorozhniy = {
  name: 'Железнодорожн',
  url: 'zheleznodorozhniy',
};

const industrialniy = {
  name: 'Индустриальн',
  url: 'industrialniy',
};

const centralniy = {
  name: 'Центральн',
  url: 'centralniy',
};

const pervomayskiy = {
  name: 'Первомайск',
  url: 'pervomayskiy',
};

const vostochniy = {
  name: 'Восточн',
  url: 'vostochniy',
};

const zapadniy = {
  name: 'Западн',
  url: 'zapadniy',
};

const pravoberezhniy = {
  name: 'Правобережн',
  url: 'pravoberezhniy',
};

const levoberezhniy = {
  name: 'Левобережн',
  url: 'levoberezhniy',
};

const promyshlenniy = {
  name: 'Промышленн',
  url: 'promyshlenniy',
};

const moskovskiy = {
  name: 'Московск',
  url: 'moskovskiy',
};

const avtozavodskiy = {
  name: 'Автозаводск',
  url: 'avtozavodskiy',
};

const proletarksiy = {
  name: 'Пролетарск',
  url: 'proletarksiy',
};

const traktorozavodskiy = {
  name: 'Тракторозаводск',
  url: 'traktorozavodskiy',
};

export const addressList: addressListProps[] = [
  {
    domain: 'msk',
    districts: [],
  },
  {
    domain: 'perm',
    districts: [
      kirovskiy,
      industrialniy,
      ordzhonikidzevskiy,
      {
        name: 'Мотовилихинск',
        url: 'motovilihinskiy',
      },
      leninskiy,
      sverdlovskiy,
      dzerzhinskiy,
    ],
  },
  {
    domain: 'interzet',
    districts: [
      {
        name: 'Невск',
        url: 'nevskiy',
      },
      {
        name: 'Приморск',
        url: 'primorskiy',
      },
      {
        name: 'Красносельск',
        url: 'krasnoselskiy',
      },
      {
        name: 'Петроградск',
        url: 'petrogradskiy',
      },
      moskovskiy,
      centralniy,
      {
        name: 'Выборгск',
        url: 'viborgskiy',
      },
      kalininskiy,
      {
        name: 'Красногвардейск',
        url: 'krasnogvardeiyskiy',
      },
      {
        name: 'Адмиралтейск',
        url: 'admiralteiyskiy',
      },
      frunzenskiy,
      {
        name: 'Василеостровск',
        url: 'vasileostrovskiy',
      },
      {
        name: 'Курортн',
        url: 'kurortniy',
      },
      {
        name: 'Пушкинск',
        url: 'pushkinskiy',
      },
      {
        name: 'Колпинск',
        url: 'kolpinskiy',
      },
      kirovskiy,
      {
        name: 'Кронштадтск',
        url: 'kronshtadtskiy',
      },
      {
        name: 'Петродворцов',
        url: 'petrodvorcoviy',
      },
      {
        name: 'Мурино',
        url: 'murino',
      },
      {
        name: 'Девяткино',
        url: 'devyatkino',
      },
      {
        name: 'Кудрово',
        url: 'kudrovo',
      },
    ],
  },
  {
    domain: 'kazan',
    districts: [
      {
        name: 'Вахитовск',
        url: 'vahitovskiy',
      },
      {
        name: 'Ново-Савиновск',
        url: 'novo-savinovskiy',
      },
      {
        name: 'Авиастроительн',
        url: 'aviastroitelniy',
      },
      {
        name: 'Приволжск',
        url: 'privolszhskiy',
      },
      kirovskiy,
      sovetskiy,
      moskovskiy,
    ],
  },
  {
    domain: 'ekat',
    districts: [
      ordzhonikidzevskiy,
      leninskiy,
      zheleznodorozhniy,
      kirovskiy,
      {
        name: 'Верх-Исетск',
        url: 'verh-isetskiy',
      },
      {
        name: 'Чкаловск',
        url: 'chkalovskiy',
      },
      oktyabrskiy,
    ],
  },
  {
    domain: 'samara',
    districts: [
      kuybyshevskiy,
      {
        name: 'Самарск',
        url: 'samarsky',
      },
      leninskiy,
      zheleznodorozhniy,
      oktyabrskiy,
      sovetskiy,
      promyshlenniy,
      kirovskiy,
      {
        name: 'Красноглинск',
        url: 'krasnoglinsky',
      },
    ],
  },
  {
    domain: 'volgograd',
    districts: [
      traktorozavodskiy,
      oktyabrskiy,
      centralniy,
      dzerzhinskiy,
      {
        name: 'Ворошиловск',
        url: 'voroshilovsky',
      },
      sovetskiy,
      kirovskiy,
      {
        name: 'Красноармейск',
        url: 'krasnoarmeysky',
      },
    ],
  },
  // Красноярск
  {
    domain: 'krsk',
    districts: [
      zheleznodorozhniy,
      kirovskiy,
      leninskiy,
      oktyabrskiy,
      sverdlovskiy,
      sovetskiy,
      centralniy,
    ],
  },
  {
    domain: 'nn',
    districts: [
      avtozavodskiy,
      {
        name: 'Канавинск',
        url: 'kanavinsky',
      },
      leninskiy,
      moskovskiy,
      {
        name: 'Нижегородск',
        url: 'nizhegorodsky',
      },
      {
        name: 'Приокск',
        url: 'prioksky',
      },
      sovetskiy,
      {
        name: 'Сормовск',
        url: 'sormovsky',
      },
    ],
  },
  // Новосибирск
  {
    domain: 'nsk',
    districts: [
      dzerzhinskiy,
      zheleznodorozhniy,
      {
        name: 'Заельцовск',
        url: 'zaelcovsky',
      },
      kalininskiy,
      kirovskiy,
      leninskiy,
      oktyabrskiy,
      pervomayskiy,
      sovetskiy,
      centralniy,
    ],
  },
  {
    domain: 'rostov',
    districts: [
      {
        name: 'Ворошиловск',
        url: 'voroshilovsky',
      },
      leninskiy,
      proletarksiy,
      zheleznodorozhniy,
      oktyabrskiy,
      sovetskiy,
      pervomayskiy,
      kirovskiy,
    ],
  },
  // Тюмень
  {
    domain: 'tmn',
    districts: [
      vostochniy,
      kalininskiy,
      leninskiy,
      centralniy,
    ],
  },
  // Ульяновск
  {
    domain: 'ulsk',
    districts: [
      leninskiy,
      zheleznodorozhniy,
      zavolzhskiy,
      {
        name: 'Засвияжск',
        url: 'zasviayzhsky',
      },
    ],
  },
  {
    domain: 'ufa',
    districts: [
      leninskiy,
      kalininskiy,
      kirovskiy,
      oktyabrskiy,
      ordzhonikidzevskiy,
      sovetskiy,
      {
        name: 'Демск',
        url: 'demsky',
      },
    ],
  },
  {
    domain: 'irkutsk',
    districts: [
      leninskiy,
      oktyabrskiy,
      pravoberezhniy,
      sverdlovskiy,
      kuybyshevskiy,
    ],
  },
  {
    domain: 'saratov',
    districts: [
      {
        name: 'Волжск',
        url: 'volszhskiy',
      },
      {
        name: 'Заводск',
        url: 'zavodskiy',
      },
      leninskiy,
      frunzenskiy,
      oktyabrskiy,
      kirovskiy,
    ],
  },
  {
    domain: 'barnaul',
    districts: [
      zheleznodorozhniy,
      industrialniy,
      leninskiy,
      oktyabrskiy,
      centralniy,
    ],
  },
  {
    domain: 'bryansk',
    districts: [
      {
        name: 'Бежицк',
        url: 'bezhitskiy',
      },
      {
        name: 'Володарск',
        url: 'volodarskiy',
      },
      sovetskiy,
      {
        name: 'Фокинск',
        url: 'fokinskiy',
      },
    ],
  },
  // Улан-Удэ
  {
    domain: 'ulu',
    districts: [
      zheleznodorozhniy,
      oktyabrskiy,
      sovetskiy,
    ],
  },
  {
    domain: 'voronezh',
    districts: [
      zheleznodorozhniy,
      {
        name: 'Коминтерновск',
        url: 'kominternovskiy',
      },
      levoberezhniy,
      leninskiy,
      sovetskiy,
      centralniy,
    ],
  },
  {
    domain: 'kirov',
    districts: [
      leninskiy,
      {
        name: 'Нововятск',
        url: 'novovyatskiy',
      },
      oktyabrskiy,
      pervomayskiy,
    ],
  },
  // Краснодар
  {
    domain: 'krd',
    districts: [
      centralniy,
      {
        name: 'Прикубанск',
        url: 'prikubanskiy',
      },
      {
        name: 'Карасунск',
        url: 'karasunskiy',
      },
      zapadniy,
    ],
  },
  {
    domain: 'kurgan',
    districts: [
      {
        name: 'Вороновка',
        url: 'voronovka',
      },
      vostochniy,
      {
        name: 'Заозёрн',
        url: 'zaozerniy',
      },
      zapadniy,
      {
        name: 'Малое Чаусово',
        url: 'maloe-chausovo',
      },
      {
        name: 'Рябково',
        url: 'ryabkovo',
      },
      {
        name: 'Северн',
        url: 'severniy',
      },
      centralniy,
      {
        name: 'Энергетики',
        url: 'energetiki',
      },
    ],
  },
  {
    domain: 'lipetsk',
    districts: [
      sovetskiy,
      oktyabrskiy,
      pravoberezhniy,
      levoberezhniy,
    ],
  },
  {
    domain: 'omsk',
    districts: [
      sovetskiy,
      pervomayskiy,
      centralniy,
      oktyabrskiy,
      leninskiy,
      kirovskiy,
      kuybyshevskiy,
    ],
  },
  {
    domain: 'oren',
    districts: [
      centralniy,
      dzerzhinskiy,
      promyshlenniy,
      leninskiy,
    ],
  },
  {
    domain: 'penza',
    districts: [
      zheleznodorozhniy,
      leninskiy,
      oktyabrskiy,
      pervomayskiy,
    ],
  },
  {
    domain: 'ryazan',
    districts: [
      zheleznodorozhniy,
      moskovskiy,
      sovetskiy,
      oktyabrskiy,
    ],
  },
  // Набережные челны
  {
    domain: 'chelny',
    districts: [
      avtozavodskiy,
      {
        name: 'Комсомольск',
        url: 'komsomolskiy',
      },
      centralniy,
    ],
  },
  {
    domain: 'tver',
    districts: [
      kirovskiy,
      leninskiy,
      oktyabrskiy,
      sovetskiy,
    ],
  },
  {
    domain: 'tomsk',
    districts: [
      kirovskiy,
      leninskiy,
      oktyabrskiy,
      sovetskiy,
    ],
  },
  {
    domain: 'tula',
    districts: [
      {
        name: 'Зареченск',
        url: 'zarechenskiy',
      },
      {
        name: 'Привокзальн',
        url: 'privokzalniy',
      },
      proletarksiy,
      sovetskiy,
    ],
  },
  {
    domain: 'izhevsk',
    districts: [
      leninskiy,
      oktyabrskiy,
      industrialniy,
      {
        name: 'Устиновск',
        url: 'ustinovskiy',
      },
      pervomayskiy,
    ],
  },
  // Челябинск
  {
    domain: 'chel',
    districts: [
      centralniy,
      kalininskiy,
      {
        name: 'Курчатовск',
        url: 'kurchatovskiy',
      },
      leninskiy,
      {
        name: 'Металлургическ',
        url: 'metallurgicheskiy',
      },
      sovetskiy,
      traktorozavodskiy,
    ],
  },
  // Чебоксары
  {
    domain: 'cheb',
    districts: [
      kalininskiy,
      leninskiy,
      moskovskiy,
      {
        name: 'Заволжье',
        url: 'zavolzhie',
      },
    ],
  },
  // Ярославль
  {
    domain: 'yar',
    districts: [
      dzerzhinskiy,
      zavolzhskiy,
      kirovskiy,
      leninskiy,
      frunzenskiy,
      {
        name: 'Красноперекопск',
        url: 'karsnoperekopskiy',
      },
    ],
  },
];
